module.exports = __webpack_public_path__ + "img/food-11.0734838e.jpg";